export const EJASchedule = [
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 01',
    schedule: '/grade-horaria-sem-logo/EJA/modulo-01.jpeg'
  },
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 02',
    schedule: '/grade-horaria-sem-logo/EJA/modulo-02.jpeg'
  },
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 04',
    schedule: '/grade-horaria-sem-logo/EJA/modulo-04.jpeg'
  },
  {
    course: 'EJA ETAPA V',
    subtitle: 'Qualificação Profissional',
    schedule: '/grade-horaria-sem-logo/EJA/qualificacao-profissional-etapa-v.png'
  },
  {
    course: 'EJA ETAPA V',
    subtitle: 'Qualificação Profissional em Auxiliar Administrativo',
    schedule: '/grade-horaria-sem-logo/EJA/qualificacao-profissional-aux-adm-etapa-v.png'
  }
];

export const EM1Schedule = [
  {
    course: '1ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM1/integral.png'
  },
  {
    course: '1ª Série Parcial Noturna',
    subtitle: 'Integrada com o Tec. em Administração',
    schedule: '/grade-horaria-sem-logo/EM1/parcial-noturna.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Agropecuária',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-agropecuaria.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Administração com Ênfase em Empreendedorismo',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-administracao.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Alimentos',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-alimentos.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Análises Clínicas',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-analises-clinicas.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Artesanato com Ênfase em Empreendedorismo',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-artesanata.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Avicultor',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-avicultor.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Bovinocultor de Leite',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-bovinocultor-de-leite.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Controle Ambiental',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-controle-ambiental.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Desenvolvimento de Sistemas',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-desenvolvimento-de-sistemas.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Farmácia',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-farmacia.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Guia de Turismo',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-guia-de-turismo.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Logística',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-logistica.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Marketing Digital',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-marketing-digital.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Modelagem do Vestuário',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-modelagem-do-vestuario.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Planejamento e Controle da Produção',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-planejamento-e-controle-da-producao.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Programação de Jogos Digitais',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-programacao-de-jogos-digitais.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Segurança do Trabalho',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-seguranca-do-trabalho.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Sistemas de Energias Renováveis',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-sistemas-de-energia-renovaveis.png'
  }
];

export const EM2Schedule = [
  {
    course: '2ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM2/integral.png'
  },
  {
    course: '2ª Série Parcial Noturna',
    subtitle: 'Integrada com o Tec. em Administração',
    schedule: '/grade-horaria-sem-logo/EM2/parcial-noturna.png'
  }
];

export const EM3Schedule = [
  {
    course: '3ª Série Parcial Regular Noturna',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/parcial-noturna.png'
  },
  {
    course: '3ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/integral.png'
  },
  {
    course: '3ª Série Parcial Tarde',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/parcial-tarde.png'
  },
  {
    course: '3ª Série Parcial Manhã',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/parcial-manha.png'
  }
];
